module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advice-8aad7cecdec366881915e9b562e045a2.webp";